export const userActions = {
  UPDATE_CURRENT_USER_ATTRIBUTES_TO_REDUX_TOKEN_AUTH: "redux-token-auth/VERIFY_TOKEN_REQUEST_SUCCEEDED",
  STORE_USER_DATA: 'STORE_USER_DATA',
  CLEAR_USER_DATA: 'CLEAR_USER_DATA',
  STORE_VALIDATION_MESSAGES: 'STORE_VALIDATION_MESSAGES',
}
